import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-sectors',
  templateUrl: './sectors.component.html'
})
export class SectorsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
